import FilterDefinitionTypeConstants from '~/constants/filter-definition-type-constants';
import NameRecord from '../NameRecord';
import {
  TagFilterDefinitionTypeRecord,
  FreeTextFilterDefinitionTypeRecord,
  RangeFilterDefinitionTypeRecord,
  SelectFilterDefinitionTypeRecord,
} from './index';

export const baseKeys: FilterDefinitionTypeBaseFields = {
  type: FilterDefinitionTypeConstants.UNDEFINED,
  name: new NameRecord(),
};

export interface FilterDefinitionTypeBaseFields {
  type: FilterDefinitionTypeConstants;
  name: NameRecord;
}

export interface FilterDefinitionTypeMethods {
  getType(): FilterDefinitionTypeConstants;
  getName(): string;
  getNameRecord(): NameRecord;
  getFormattedFilterName(): string;
  getFilterKey(): string;
}

export type FilterDefinitionType =
  | SelectFilterDefinitionTypeRecord
  | TagFilterDefinitionTypeRecord
  | RangeFilterDefinitionTypeRecord
  | FreeTextFilterDefinitionTypeRecord;
